import {Period} from '../../common/model/period.model';
import {Legend} from '../../common/model/legend.model';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {Helpers} from '../../common/helpers/helpers';
import {CategoriaTipiEo} from '../categoriatipieo/categoriatipieo.model';

import { from } from 'rxjs';
export class TipoEntitaOrganizzativa extends Period {

  public static DIPARTIMENTO = 21;
  public static ISTITUTO = 1;
  public static RSU = 33;
  public static LIVELLO_PADRE_SEDI = 'LPS';

  constructor(protected id: number,
              public descr: string,
              public sigla: string,
              public colore: string,
              public categorie: any[],
              public inizioValidita: Date,
              public fineValidita: Date,
              public fasciaRequired: boolean) {
    super(id, inizioValidita, fineValidita);
  }

  public static getTableKeys() {
    return ['id', 'descr', 'sigla', 'inizioValidita', 'fineValidita'];
  }

  public getLabel() {
    return this.descr;
  }

  public getCategorie() {
    return this.categorie;
  }

  public getLegend(): Legend {
    return new Legend('cube', this);
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('id', new TableRowValue(this.id, null));
    rowValues.set('descr', new TableRowValue(this.descr, null));
    rowValues.set('sigla', new TableRowValue(this.sigla, null));
    rowValues.set('inizioValidita', new TableRowValue(Helpers.formatDateView(this.getInizio()), null));
    rowValues.set('fineValidita', new TableRowValue(Helpers.formatDateView(this.getFine()), null));
    return new TableRow(this, rowValues);
  }
}
